import Layout from '@/layout/layout'

const financeOrderRouter = {
    path: '/externalFunction',
    component: Layout,
    redirect: 'noRedirect',
    name: '外部功能',
    children: [
        {
            path: 'functionItemManage',
            component: () => import('@/views/externalFunction/functionItemManage/index'),
            name: '外部功能项管理',
            meta: {title: '外部功能项管理', noCache: true}
        },
    ]
}

export default financeOrderRouter
